import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#8472AF", fillRule: "evenodd", d: "M12.62 2v16l4.084-3.264V4.222zm-1.9 12.512-3.314 1.44V3.378l3.315.98zm-5.213-1.03L3 14.14V5.054l2.507.397z", clipRule: "evenodd" }));
const SvgMarketoLightmode = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgMarketoLightmode;
